<template lang="pug">
    .card.right-side-card.thank-you-card
        h5.card-header
            p Thank you, your booking is complete. Details are provided below.
            p.mb-0 The payment will be captured once your booking is Confirmed by Game Master.
        .card-body
            .profile
                img.profile__image(:src="`${baseUri}${profileImage}`")
                .profile__name-and-location
                    .profile__name {{ profile.name }}
                    .profile__location {{ location }}
            hr
            .two-cols
                .left Game
                .right {{ gameTitle }}
            hr
            .two-cols
                .left Date
                .right
                    time(:datetime="date") {{ date }}
            hr
            .two-cols
                .left Hours
                .right {{ item.options.slots }}
            hr
            .two-cols
                .left Players
                .right {{ item.options.participants }}
            hr
            .two-cols.mb-2
                .left Extra Services:
            .two-cols
                .left Add-Ons
                .right {{ addonsPrice | currency }}
            hr
            .two-cols.mb-3
                .left Subtotal:
                .right {{ subtotal | currency }}
            .two-cols.mb-3(v-if="mileageFee > 0")
                .left Mileage Fee:
                .right {{ mileageFee | currency }}
            .two-cols.mb-3
                .left Service Fee:
                .right {{ order.fees | currency }}
            .two-cols
                .left Total:
                .right {{ order.total | currency }}
            hr
            .btn.btn-danger.btn-lg.total-cost-btn
                .two-cols
                    span Total Cost:
                    span {{ order.total | currency }}

</template>

<script>
import moment from 'moment'

export default {
    name: 'thank-you',

    props: {
        profile: {
            type: Object,
            required: true,
        },
        order: {
            type: Object,
            required: true,
        },
    },

    computed: {
        item() {
            return this.order.items.data[0]
        },
        date() {
            return moment(this.item.options.start_at).format('MMMM D, y')
        },
        product() {
            return this.profile.product.data
        },
        location() {
            return `${this.product.location.city}, ${this.product.location.state}`
        },
        profileImage() {
            return this.profile.profile_image || '/images/client/lairdnd/default-profile-image.png'
        },
        addonsPrice() {
            return Object.entries(this.item.options.upgrades).reduce((a, c) => {
                return a + this.product.upgrades.find(u => u.name == c[0]).price * c[1]
            }, 0)
        },
        subtotal() {
            return this.addonsPrice + this.item.product.data.rates[0].price * this.item.options.slots
        },
        mileageFee() {
            return this.order.price - this.subtotal
        },
        gameTitle() {
            return window.addiesaas.lairdnd.games
                .find(game => game.name == this.item.options.game)
                .title
        },
    }
}
</script>
